export default __webpack_public_path__ + "static/media/reims2.e32074be.jpg";